(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ChannelConf', ChannelConf);

    ChannelConf.$inject = ['$resource'];

    function ChannelConf ($resource) {
        var resourceUrl =  'api/channel-conf/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getChannel': {
            	url:'api/channel',
                method: 'GET',
                isArray: true
            },
            'testMessage': {
            	url:'api/channel-conf/test-message',
                method: 'POST'
            },
            'update': { method:'PUT' }
        });
    }
})();
